export default __webpack_public_path__ + "static/media/Tik-campus.93171708.svg";